import { InteractionType } from '@azure/msal-browser';
import { MsalAuthenticationTemplate } from '@azure/msal-react';
import { config } from 'application';
import ErrorPage from 'pages/errors/ErrorPage';
import HelpPage from 'pages/HelpPage/HelpPage';
import HomePage from 'pages/HomePage';
import PartnersPage from 'pages/PartnersPage/PartnersPage';
import TemplatesPage from 'pages/TemplatesPages/TemplatesPage';
import UploadFormPage from 'pages/UploadFormPage/UploadFormPage';
import UploadsPage from 'pages/UploadsPage/UploadsPage';
import { createBrowserRouter } from 'react-router-dom';
import { createPaths } from 'utils/pathFactory';

const pathsList = {
  home: '/',
  signIn: '/sign-in',
  templates: '/templates',
  uploads: '/uploads',
  upload: '/upload',
  dashboard: '/dashboard',
  partners: '/partners',
  help: '/help',
};

export type TPath = keyof typeof pathsList;

export const paths = createPaths(pathsList);

export const routes = [
  {
    errorElement: <ErrorPage />,
  },
  {
    path: paths.home.pattern,
    element: <HomePage />,
  },
  {
    path: paths.templates.pattern,
    element: <TemplatesPage />,
  },
  {
    path: paths.uploads.pattern,
    element: <UploadsPage />,
  },
  {
    path: paths.upload.pattern,
    element: <UploadFormPage />,
  },
  {
    path: paths.help.pattern,
    element: <HelpPage />,
  },
  {
    path: paths.partners.pattern,
    element: <PartnersPage />,
  },
  {
    path: paths.signIn.pattern,
    element: <MsalAuthenticationTemplate interactionType={InteractionType.Redirect}></MsalAuthenticationTemplate>,
  },
];

export const browserRouter = createBrowserRouter(routes, {
  basename: config.router.basename,
});
